import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_maintain_parental_permission_of_wrkrs_und_the_age'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_maintain_parental_permission_of_wrkrs_und_the_age',
  name: 'Does the facility maintain parental permission of workers under the age of 18 to work in the facility in line with legal requirements?',
  description:
    'For example:\r\r\n\r\r\nAnswer Yes if the permission is maintained as legally required. \r\r\n\r\r\nAnswer No if either permission is not maintained (and it is required) OR permission is maintained, but in a way that does not meet legal requirements.\r\r\n\r\r\nConsult applicable legal requirements before answering this question. \r\r\n\r\r\nIf there are no applicable legal requirements, answer No applicable legal requirements.',
  meta: {},
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no-nalr',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
    },
    {
      name: 'No applicable legal requirements',
      key: 'NO_APPLICABLE_LEGAL_REQS',
      slcpIndex: 3,
      slcpOptionName: 'yes-no-nalr',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO', 'NO_APPLICABLE_LEGAL_REQS'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'cl-4--2',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 4500,
  sectionId: '2.2.1',
  impactArea: 'Child Labour',
  impactAreaId: 'CHILD_LABOR',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
